<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import fractionBuilder from './functions/fractionBuilder';

	export let uqn: number;

	let qn: string;
	let points: string, complexes: string;
	$: qn = uqnToQn(uqn);
	$: type = Number(uqn.toString()[0]);
	$: qnPart2 = type%2==1? fractionBuilder("z^2","z^*",true) : fractionBuilder("z^3",4*Math.pow(Number(uqn.toString()[1]),2),true);
	$: qnPart1 = type%2==1? fractionBuilder("z^2","z^*",true) : "z^3";
	$: [points, complexes] = uqnToPoints(uqn);

	function uqnToQn(u:number):string{
		let [t,a,s] = uqnSplit(u);
		if (s==1){
			a *= -1;
		}
		let zString: string;
		if (t==1 || t==2){
			zString = "a";
			if (a>0){
				zString += "+"
			}
			if (a==1){
				zString += "i";
			} else if (a==-1){
				zString += "-i";
			} else{
				zString += a.toString() + "i";
			}
		} else{
			zString = a.toString() + "+bi";
		}
		return zString;
	}

	const uqnToPoints = (u:number) => {
		let [t,a,s] = uqnSplit(u);
		let pts = "A,B,C,D";
		let c = "z, "+qnPart2+", z^*," + fractionBuilder( (2*Math.pow(Number(uqn.toString()[1]),2)).toString(),"z");
		if ( !((t==3||t==4) && s==1) ){
			pts += ",E";
			c += ", " +fractionBuilder("z^2",(2*Number(uqn.toString()[1])).toString());
		}
		return [pts, c];
	}
</script>

<p> 
	The complex number
	<Katex math={"z"}/>
	is given by
	<Katex math={"z="+qn}/>, where
	{#if type<3}
	<Katex math="a"/>
	{:else}
	<Katex math="b"/>
	{/if}
	is a real number.
</p>

<p class="qnpart">
	(a) Find the possible values of
	{#if type<3}<Katex math="a"/>{:else}<Katex math="b"/>{/if}
	if <Katex math={qnPart1}/>
	is
	{#if type<3}purely imaginary.{:else}real.{/if}
</p>
<p>
	For the rest of the question it is further given that 
	{#if type<3}
		<Katex math={"a>0."}/>
	{:else}
		<Katex math={"b>0."}/>
	{/if}
</p>
<p class="qnpart">
	(b) Find the smallest integer value of <Katex math="n"/> such that
	<Katex math={"\\left | z^n \\right | \\geq 1000."}/>
</p>
<p class="qnpart">
	(c) For the value of <Katex math="n"/> found in (b) find the values of
	<Katex math={"\\left|z^n\\right|"}/> and <Katex math={"\\textrm{arg}(z^n)"}/>, where
	<Katex math={"-\\theta < \\textrm{arg}(z^n) \\leq \\theta."}/>
</p>
<p class="qnpart">
(d) On a single Argand diagram mark out the points <Katex math={points}/>
	representing the complex numbers <Katex math={complexes}/>
	respectively.
</p>

